export const POCKETBASE_URL = 'https://pb-9447199.seraphsystems.com/';

// Dashboard configuration
export const DASHBOARD_CONFIG = {
  // List of statuses to display in the dashboard
  // You can modify this array to show/hide specific statuses
  displayStatuses: [
    'NOT_READY',
    'PACKING',
    'PARTIALLY_READY',
    'READY',
    'ON_ROUTE',
    'DELIVERED',
  ]
};
